export const getRiskLabel = (risk: string) => {
  switch (risk) {
    case "very_high_risk":
      return "Very High risk"
    case "high_risk":
      return "High risk"
    case "medium_risk":
      return "Med risk"
    case "low_risk":
      return "Low risk"
    default:
      return risk
  }
}
